'use client'

import { usePopup } from '@/contexts/PopupContext'
import { Card, CardBody, CardFooter, CardHeader } from '@nextui-org/react'
import React from 'react'
import { MdCheckCircle, MdError, MdWarning, MdInfo } from 'react-icons/md'
const statusIcons = [
    <MdCheckCircle key={1} />,
    <MdError key={2} />,
    <MdWarning key={3} />,
    <MdInfo key={4} />
]


const Popup = () => {
    const { popup, setPopup, showPopup, setShowPopup } = usePopup();
    return (
        <section className={`${showPopup ? 'flex' : 'hidden'} bg-[#000000af] backdrop-blur-sm w-screen h-screen fixed top-0 flex-col items-center justify-center z-50`}>
            <Card className={`flex flex-col gap-4 w-[96%] max-w-[360px]`}>
                <CardHeader className='flex justify-between items-center p-4'>
                    {popup.title} {statusIcons[popup.status]}
                </CardHeader>
                <CardBody className='flex flex-col items-center justify-center text-center'>
                    {popup.message}
                </CardBody>
                <CardFooter className='flex gap-4 items-center justify-center'>
                    {
                        popup.noAction && <button className='px-4 p-2 w-full bg-red' onClick={popup.noAction}>No</button>
                    }
                    {
                        popup.yesAction ? <button className='px-4 p-2 w-full bg-green-400 rounded-full' onClick={popup.yesAction}>Yes</button> : null
                    }
                    {
                        !popup.noAction && !popup.yesAction && <button className='px-4 p-2 w-full bg-amber-500 rounded-full' onClick={() => {
                            if (popup.defaultAction) {
                                popup.defaultAction()
                            }
                            setShowPopup(false)
                        }}>
                            Okay
                        </button>
                    }
                </CardFooter>
            </Card>
        </section>
    )
}

export default Popup